<template>
  <v-container ma-0 pa-0>
    <v-layout justify-center row wrap>
      <v-flex xs12 ma-0 pa-0>
        <v-toolbar card prominent>
          <v-toolbar-title>
            Riders
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="nameFilter"
            @input="setFilter = true"
            class="pr-2 pl-2"
            placeholder="Search Riders by name"
            clearable
            clear-icon="mdi-close-circle"
          />
         <!-- <v-divider vertical></v-divider>
          <v-overflow-btn
            v-model="accountTypeFilter"
            :items="accountTypes"
            @change="setFilter = true"
            label="Filter By Account Type"
            hide-details
            class="pr-2 pl-2"
          ></v-overflow-btn> -->
           <v-divider
            class="mr-2"
            vertical
          ></v-divider>
          <v-btn :disabled="!setFilter" outline color="grey darken-1 white--text" @click="clearFilters()">
            Reset
          </v-btn>
          <v-btn :disabled="!setFilter" depressed color="info white--text" @click="applyFilter()">
            Search
          </v-btn>
        </v-toolbar>
        <v-divider/>
        <v-layout row wrap justify-center>
          <v-flex xs12 pa-0>
            <v-card pa-0 flat>
              <v-card-text color="white" class="pa-0 pt-3 pb-3">
                <v-layout row wrap>
                  <v-flex xs2 pl-4>
                    First Name
                  </v-flex>
                  <v-flex xs2>
                    Last Name
                  </v-flex>
                  <v-flex xs1>
                    Bike Number
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs1 text-xs-right>
                    Found {{totalFilterCount}} Results
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-divider/>
        <v-layout v-if="(!riderCount || riderCount === 0)" row wrap>
          <v-flex xs12 pa-3>
            <em>Loading Registry...</em>
          </v-flex>
        </v-layout>
        <v-layout v-else-if="searching" row wrap>
          <v-flex xs12 pa-3>
            <em>Searching Registry...</em>
          </v-flex>
        </v-layout>
        <v-layout v-else row wrap justify-center>
          <v-flex xs12 pa-0>
            <v-card flat>
              <v-card-text class="pa-0 riderCard" v-for="(rider, ix) in riders" :key="ix">
                <v-layout row wrap>
                  <v-flex xs2 pt-3 pb-3 pl-4>
                    {{ rider.first }}
                  </v-flex>
                  <v-flex xs2 pt-3 pb-3 pl-1>
                    {{ rider.last }}
                  </v-flex>
                  <!-- <v-flex xs2>
                    <v-text-field class="mt-0"
                      hide-details
                      mask="###"
                      maxLength="4"
                      placeholder="Set Rider Bike Number"
                      :value="rider.bikeNo"
                    />
                  </v-flex> -->
                  <v-flex xs2 pt-3 pb-3 pl-1>
                    {{ rider.bikeNo }}
                    <v-spacer/>
                    <v-btn small fab flat>
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-spacer/>
                  <v-flex xs1 text-xs-right>
                    <v-btn fab outline small color="grey lighten-1">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 text-xs-center>
            <v-card>
              <v-pagination
                v-model="pageNo"
                :length="Math.ceil(totalFilterCount / this.pageLimit)"
              ></v-pagination>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
// import TestMembers from '@/data/uncreated-full.json'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    user () {
      return store.state.user
    },
    ...mapGetters({
      memberCount: 'getTotalCount',
      totalFilterCount: 'getFilterCount'
    }),
    filteredMembers () {
      let first = (this.pageNo - 1) * this.pageLimit
      let last = first + this.pageLimit
      let members = store.state.admin.filtered || null
      console.log('Filer members')
      console.log(members)
      console.log(`Show ${this.pageLimit} Members on Page #${this.pageNo}`)
      if (members) return members.slice(first, last)
      return null
    },
    filterCount () {
      return (this.filteredMembers) ? Object.keys(this.filteredMembers).length : 0
    },
    riderCount () {
      return (this.riders) ? Object.keys(this.riders).length : 0
    },
    riders () {
      if (!this.filteredMembers) return null
      console.log('Create Riders')
      let riders = []
      let i = 0
      const keys = Object.keys(this.filteredMembers)
      const iMax = keys.length
      for (; i < iMax; i++) {
        let acc = this.filteredMembers[keys[i]]
        console.log(acc)
        let members = acc.accountMembers || []
        if (!members) continue
        members.forEach(item => {
          let rider = {
            memNo: acc.membership.membershipNo,
            email: acc.details.email,
            accFirst: acc.details.firstName,
            accLast: acc.details.lastName,
            id: item.id,
            first: item.firstName,
            last: item.lastName,
            bikeNo: item.bikeNo
          }

          riders.push(rider)
        })
      }

      console.log(riders)
      return riders
    }
  },
  methods: {
    ...mapActions([
      'getMembers',
      'applyMemberFilters',
      'setTestMembers',
      'setMemberPage'
    ]),
    applyFilter: async function () {
      console.log('Apply Filters')
      console.log(this.nameFilter)
      console.log(this.accountTypeFilter)
      this.pageNo = 1
      let finished = await this.applyMemberFilters({
        text: this.nameFilter,
        type: this.accountTypeFilter
      })
      if (finished) {
        console.log('Apply Filter Done')
      }
    },
    clearFilters: async function () {
      this.nameFilter = null
      this.accountTypeFilter = 'all'
      this.pageNo = 1
      this.searching = true
      this.setFilter = false
      await this.applyMemberFilters()
      this.searching = false
    },
    formatDate: function (timestring) {
      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let time = new Date(timestring)
      let newFormat = `${days[time.getDay()]}, ${time.getDate()} ${months[time.getMonth() + 1]} ${time.getFullYear()}`
      // let newFormat = time.getDate() + "-" + (time.getMonth() + 1) + "-" + time.getFullYear()
      return newFormat
    },
    formatMemberSince: function (timestring) {
      let time = new Date(timestring)
      let newFormat = `${time.getDate()}/${time.getMonth() + 1}/${time.getFullYear()}`

      let nowYear = new Date().getFullYear()
      let yearDiff = nowYear - time.getFullYear()

      if (yearDiff === 0) return newFormat
      if (yearDiff === 1) return newFormat + ' (1 Year)'

      return newFormat + ` (${yearDiff} Years)`
    },
    generateAddressString: function (details) {
      return `${details.address.street} ${details.address.suburb} ${details.address.postcode} ${details.address.state}`
    },
    memberStatus: function (member) {
      if (member.membership.type === 'life') return 'active'
      let now = new Date().getTime()
      let endDate = member.membership.current.subscriptionEnds
      let ends = new Date(endDate).getTime()
      if (ends >= now) return 'active'

      return 'inactive'
    },
    generateAccountType (member) {
      let account = 'General Member'
      if (member.membership.type === 'life') account = 'Life Member'
      if (member.committee.optin === true && member.committee.active) account = 'General Committee'
      if (member.executive && member.executive.active) account = 'Executive Board'

      return account
    }
  },
  data () {
    return {
      active: null,
      searching: false,
      setFilter: false,
      nameFilter: null,
      pageNo: 1,
      pageLimit: 20,
      accountTypeFilter: 'all',
      activeFilter: null,
      accountTypes: [
        {
          text: 'All',
          value: 'all'
        },
        {
          text: 'General Members',
          value: 'member'
        },
        {
          text: 'Life Members',
          value: 'life'
        },
        {
          text: 'Committee Members',
          value: 'committee'
        },
        {
          text: 'Executive Board Members',
          value: 'executive'
        }
      ]
    }
  },
  mounted () {
    this.getMembers()
    // this.setTestMembers(TestMembers.users)
  }
}
</script>
<style>
  #specialOffer {
    font-size: 2rem;
    background-color: darkgreen;
    padding: 5px 20px;
    border-radius: 3px;
    width: fit-content;
    color: white;
  }
  em.inactive {
    color: orange;
  }
  em.active {
    color: green;
  }
  .riderCard {
    box-shadow: none !important;
    border-bottom: solid 1px lightgrey;
  }
</style>
